
import ListComponent from "../../../components/gift_records/Index.vue";

export default {
  components: {
    ListComponent
  }
}
